import { render, staticRenderFns } from "./transactionDetail.vue?vue&type=template&id=68a2168e&scoped=true&xmlns%3Av-clipboard=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./transactionDetail.vue?vue&type=script&lang=js&"
export * from "./transactionDetail.vue?vue&type=script&lang=js&"
import style0 from "./transactionDetail.vue?vue&type=style&index=0&id=68a2168e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a2168e",
  null
  
)

export default component.exports